<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(login)" class="px-8 pt-2 pb-6 w-full relative">
      <div class="flex flex-col">
        <ValidationProvider rules="required|email" v-slot="{ errors }">
          <label class="font-bold" :for="$t('Forms.email')">
            {{ $t("Forms.email") }}
          </label>
          <input type="email" v-model="formLogin.Username" :class="[errorLogin.username && 'border-newxcaret-red']"
            :placeholder="$t('Forms.email')" :name="$t('Forms.email')" class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                    " />
          <p class="txt-error text-red text-xs italic mb-2">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <p class="txt-error text-red text-xs italic" v-if="errorLogin.username">
          {{ responseErrors.Username[0] }}
        </p>

        <ValidationProvider rules="required" v-slot="{ errors }">
          <label class="font-bold" :for="$t('Forms.password')">
            {{ $t("Forms.password") }}
          </label>
          <input type="password" v-model="formLogin.Password" :class="[errorLogin.password && 'border-newxcaret-red']"
            :placeholder="$t('Forms.password')" :name="$t('Forms.password')" class="
                      w-full
                      h-10
                      p-3
                      my-2
                      border border-newxcaret-blue
                      bg-white
                      rounded-lg
                    " />
          <p class="txt-error text-red text-xs italic mb-1">
            {{ errors[0] }}
          </p>
        </ValidationProvider>
        <p class="txt-error text-red text-xs italic mb-4" v-if="errorLogin.password">
          {{ responseErrors.Password[0] }}
        </p>

        <p class="text-red text-xs italic mb-4" v-if="msgApi.error">
          {{ msgApi.message }}
        </p>

        <div class="flex justify-between p-2">
          <div>
            &nbsp;
          </div>

          <router-link :title="$t('Forms.forgot_password')" class="cursor-pointer text-link-blue"
            :to="{ name: 'forgot' }">{{ $t("Forms.forgot_password") }}</router-link>
        </div>

        <div class="flex justify-center">
          <button type="submit" :disabled="loading" class="
                      w-full
                      text-center
                      uppercase
                      p-2
                      bg-green-xcaret
                      text-white
                      rounded-full
                      my-2
                      text-sm
                      tracking-wider
                    ">
            {{ $t("Forms.login") }}
          </button>
        </div>

        <div class="pb-2 flex flex-col justify-center items-center hidden">
          <p class="text-sm text-center py-3 font-semibold text-grey">
            {{ $t("Forms.social_login") }}
          </p>

          <button class="
                      w-full
                      uppercase
                      bg-blue-700
                      text-white
                      rounded-lg
                      my-2
                      px-12
                      sm:py-2 sm:text-sm
                      text-xs
                      tracking-wider
                      shadow-lg
                      focus:outline-none
                    " type="button">
            <!-- <font-awesome-icon :icon="['fab', 'facebook']" /> -->

            Continua con Facebook
          </button>

          <button class="
                      w-full
                      uppercase
                      bg-red-700
                      text-white
                      rounded-lg
                      my-2
                      px-12
                      sm:py-2 sm:text-sm
                      text-xs
                      tracking-wider
                      shadow-lg
                      focus:outline-none
                    " type="button">
            <!-- <font-awesome-icon :icon="['fab', 'google']" /> -->

            Continua con Google
          </button>

          <button class="
                      w-full
                      uppercase
                      bg-black
                      text-white
                      rounded-lg
                      my-2
                      px-12
                      sm:py-2 sm:text-sm
                      text-xs
                      tracking-wider
                      shadow-lg
                      focus:outline-none
                    " type="button">

            Continua con Apple ID
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import "../validators/index";
// Cargamos el archivo para las traducciones
import i18n from "../../i18n";
import methodUser from "../mixins/methodUser";

import Users from "../mixins/Users";
import AlbumsMix from "../mixins/albums/GetAlbumsByEmail";
import SearchPackage from "../photo/searchPackageComponent";
import loginData from "../logic/profile/login";

export default {
  props: [],
  mixins: [methodUser, Users, AlbumsMix],
  components: {
    SearchPackage,
  },
  data: () => ({
    user: {},
    pathname: window.location.origin + "/",
    BirthdateInput: { name: "Birthdate" },
    loading: false,
    formLogin: {
      Username: "",
      Password: "",
    },
    formRegister: {
      Password: "", //*
      Email: "", //example@email.com
      FirstName: "", //test
      LastName: "", //test
      Phone: "",
      Birthdate: "", //31/12/1982
      Locale: "", //Mexico
      Gender: "", //Masculino
      Title: "", //Sr.
    },
    formActiveNewUser: {
      Email: "", //example@email.com
      Code: "",
      helperBtnSend: true,
    },
    formResetPassword: {
      Email: "", //example@email.com
      Code: "",
      Password: "",
      helperBtnSend: true,
    },
    formRecoveryPass: {
      Email: "",
    },
  }),
  watch: {
    activeForm: function () {
      this.errorLogin.statusApiMessage = false;
      this.msgApi.success = false;
      this.msgApi.error = false;
      this.disableAllInputs();
    },
  },
  methods: {
    async login() {
      try {
        this.$store.dispatch("setLoading", true);
        // POST request using axios
        let response = await loginData.get(this.formLogin);
        let lang = this.$store.state.Language;

        if (this.errorFormInput(response.data, "status")) {
          //Elemento que recupera todos los error de validacion de campos
          this.responseErrors = response.data.errors;

          Object.entries(this.responseErrors).forEach(([key, value]) => {
            this.validFieldsRegister(this.responseErrors);
          });
        } else {
          this.errorLogin.username = false;
          this.errorLogin.password = false;
          if (this.errorFormInput(response.data, "ACCESS")) {
            // almacenamos el correo del usuario loggeado para usarlo donde se requiera
            this.$store.dispatch('setUserEmail', this.formLogin.Username);
            this.setUserLoggedIn(response.data.ACCESS == true ? true : false);
            this.$store.dispatch("setUserGuest", false);
            this.$store.dispatch("setModalLogin", false);
            await this.getAlbumsByEmail();
          } else {
            if (
              this.errorFormInput(response.data, "SUCCESS") &&
              this.errorFormInput(response.data, "MESSAGE")
            ) {
              if (response.data.SUCCESS == "false") {
                this.msgApi.error = true;
                this.msgApi.message = response.data.MESSAGE;
              }
            }
          }
        }
        //se settea el loadign para desaactivarlo
        this.$store.dispatch("setLoading", false);
      } catch (error) {
        this.$store.dispatch("setLoading", false);
      }
    }
  },
  mounted() { },
};
</script>